import React from 'react';

import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { withRouter } from 'react-router-dom';

import {
    parseSearch,
    addParamsToSearch
} from '@src/utils/urlHelpers';

import './SearchForm.scss';

export class SearchForm extends React.PureComponent {
    static propTypes = {
        onSubmit: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
        }).isRequired,
        history: PropTypes.shape({
            replace: PropTypes.func.isRequired,
        }).isRequired,
    };

    constructor(props) {
        super(props);

        this.input = React.createRef();
    }

    setInputValue() {
        const { location: { pathname, search } } = this.props;

        // If we are not on the search page the `q` parameter is not for search
        if (pathname !== '/search') {
            return;
        }

        const searchParams = parseSearch(search);
        this.input.current.value = searchParams.q || '';
    }

    scrollToInput() {
        document.querySelector('[id="search-results-header"]').scrollIntoView();
    }

    componentDidMount() {
        this.setInputValue();
        this.input.current.focus();
    }

    componentDidUpdate(prevProps) {
        const { location: { pathname, search } } = this.props;
        const { location: { pathname: prevPathname, search: prevSearch } } = prevProps;

        if (pathname !== prevPathname || search !== prevSearch) {
            this.setInputValue();
            this.scrollToInput();
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { onSubmit, history, location: { search } } = this.props;

        const term = this.input.current.value;
        const searchParams = addParamsToSearch(parseSearch(search), { q: term });

        history.replace({ pathname: '/search', search: searchParams });

        if (onSubmit) {
            onSubmit();
        }
    };

    render() {
        return (
            <Form className="search-form" onSubmit={this.handleSubmit}>
                <Form.Group controlId="term">
                    <Form.Label>Enter your search here</Form.Label>
                    <Form.Control key="input" ref={this.input} placeholder="What can we help you find?" />
                    <button id="search_btn" type="submit" title="Search" />
                </Form.Group>
            </Form>
        );
    }
}

export default withRouter(SearchForm);
